module.exports = __webpack_public_path__ + "files/f71f23499963d2fa08668b48960f87fc.png";